import { useState } from 'react'
import { Paper, Text, Group, Stack, UnstyledButton, Collapse, Box } from '@mantine/core'
import { IconChevronDown } from '@tabler/icons-react'
import { StatusMeter } from '../common/StatusMeter'
import { EvidenceQuote } from './EvidenceQuote'

function scoreColor(score) {
  if (score >= 80) return 'cyan'
  if (score >= 60) return 'green'
  if (score >= 40) return 'orange'
  return 'red'
}

const LEVEL_SCORES = { emerging: 30, developing: 55, proficient: 80, advanced: 95 }

export function LivingSkillCard({ skill }) {
  const [expanded, setExpanded] = useState(false)
  // Support both legacy shape {skill, score, evidence} and AI shape {name, level, description}
  const skillName = skill.skill || skill.name || 'Unknown Skill'
  const score = skill.score ?? LEVEL_SCORES[skill.level] ?? 50
  const evidence = skill.evidence || []
  const description = skill.description

  return (
    <Paper
      p="md"
      className="glass"
      style={{ borderColor: 'rgba(0, 229, 255, 0.12)' }}
    >
      <Stack gap="sm">
        <Group justify="space-between" align="flex-start">
          <Box style={{ flex: 1 }}>
            <Text
              size="sm"
              fw={700}
              ff="Orbitron, sans-serif"
              c="cyan.3"
              mb={4}
            >
              {skillName}
            </Text>
            <StatusMeter value={score} color={scoreColor(score)} />
          </Box>
          <Text
            size="xl"
            fw={700}
            ff="Orbitron, sans-serif"
            c={`${scoreColor(score)}.4`}
            style={{ minWidth: 48, textAlign: 'right' }}
          >
            {score}
          </Text>
        </Group>

        {description && evidence.length === 0 && (
          <Text size="xs" c="dimmed">{description}</Text>
        )}

        {evidence.length > 0 && (
          <>
            <UnstyledButton
              onClick={() => setExpanded((v) => !v)}
              style={{ width: '100%' }}
            >
              <Group gap={4} justify="center">
                <Text size="xs" c="dimmed" fw={600}>
                  {expanded ? 'Hide' : 'Show'} Evidence ({evidence.length})
                </Text>
                <IconChevronDown
                  size={14}
                  color="var(--mantine-color-dimmed)"
                  style={{
                    transform: expanded ? 'rotate(180deg)' : 'rotate(0)',
                    transition: 'transform 0.2s ease',
                  }}
                />
              </Group>
            </UnstyledButton>

            <Collapse in={expanded}>
              <Stack gap={0} mt={4}>
                {evidence.map((ev, i) => (
                  <EvidenceQuote key={i} evidence={ev} />
                ))}
              </Stack>
            </Collapse>
          </>
        )}
      </Stack>
    </Paper>
  )
}
